import { Action } from "redux";
import { ProcessCountState } from "../model/ProcessCountState";

import * as SignalRActions from "../actions/SignalRActions";

export function processCounts(state: ProcessCountState = {}, action: Action): ProcessCountState {
    switch (action.type) {
        case SignalRActions.RESET_PROCESS_COUNTS: {
            const resetAction = action as SignalRActions.ReceiveProcessCountsAction;
            const copyResetState = JSON.parse(JSON.stringify(state)); // faster than _.cloneDeep
            return applyCountUpdates(copyResetState, resetAction.processCounts, true);
        }
        case SignalRActions.UPDATE_PROCESS_COUNTS: {
            const updateAction = action as SignalRActions.ReceiveProcessCountsAction;
            const copiedState = JSON.parse(JSON.stringify(state)); // faster than _.cloneDeep
            return applyCountUpdates(copiedState, updateAction.processCounts, false);
        }
        default:
            return state;
    }
}

function applyCountUpdates(stateToUpdate: ProcessCountState, newCounts: ProcessCountState, resetProcCounts: boolean) {
    for (const envKey of Object.keys(newCounts)) {
        const newEnvData = newCounts[envKey];
        if (!stateToUpdate[envKey]) {
            stateToUpdate[envKey] = {};
        }

        for (const procKey of Object.keys(newEnvData)) {
            const newProcData = newEnvData[procKey];
            if (resetProcCounts) {
                // just reset proc data for all dates
                stateToUpdate[envKey][procKey] = newProcData;
            } else {
                if (!stateToUpdate[envKey][procKey]) {
                    stateToUpdate[envKey][procKey] = {};
                }

                for (const dateKey of Object.keys(newProcData)) {
                    // overwrite date entry with the latest values
                    stateToUpdate[envKey][procKey][dateKey] = newProcData[dateKey];
                }
            }
        }
    }

    return stateToUpdate;
}
